module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-1.4249746c.jpg";